/* eslint-disable react/prop-types */
import * as Accordion from '@radix-ui/react-accordion';
import React from 'react';
import Form from 'react-bootstrap/Form';
import { AccordionContent, AccordionTrigger } from '../common/Accordion';
import ArchivedObjectPrint from './ArchivedObjectPrint';
import Tab from './Tab';
const ArchivedObjectAccordions = ({
  tabs,
  Field,
  formRef,
  validated,
  mode,
  defaultImage,
}) => {
  if (tabs.length === 0) {
    return null;
  }
  if (mode === 'print') {
    return <ArchivedObjectPrint tabs={tabs} Field={Field} />;
  }
  return (
    <div id="MetaDataDisplayDiv" className="meta smallPane">
      <Accordion.Root type="multiple" defaultValue={[]}>
        <Form validated={validated} ref={formRef}>
          {tabs.map((tab, i) => {
            return (
              <Accordion.Item
                key={i}
                value={'item-' + i}
                style={{ marginBottom: '5px' }}
              >
                <AccordionTrigger>
                  <span>
                    <i className="fa fa-file" />
                    <strong style={{ textTransform: 'none' }}>
                      {tab.label}
                    </strong>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="mdContainerBody">
                  <Tab tab={tab} Field={Field} mode={mode} defaultImage={defaultImage}/>
                </AccordionContent>
              </Accordion.Item>
            );
          })}
        </Form>
      </Accordion.Root>
    </div>
  );
};
export default ArchivedObjectAccordions;